import { Component, OnInit, inject } from '@angular/core';
import { P404Component } from '@nimmsta/ng-commons-lib/error-pages';
import { ProductFruitsService } from '../../services/productfruits.service';

@Component({
  selector: 'app-p404-ext',
  template: '<app-p404></app-p404>',
  imports: [P404Component],
})
export class P404ExtComponent extends P404Component implements OnInit {
  private productFruits = inject(ProductFruitsService);

  ngOnInit(): void {
    this.productFruits.destroy();
  }
}
